import { IMutations } from '@/models/store/mutations.interface';
import state from './state';

const mutations: IMutations = {
	selectFileUpload: (fileUpload) => {
		state.selectedFileUpload = fileUpload;
	},
	setCurrentRoute: (name, id) => {
		state.router.current = name;

		// Maintain a url format which uses a hash to separate the universityAdmin url part from the microservice url part.
		const url = `${window.location.origin}/data-import-system/#/${name}`;

		// Keep the url in the address bar up-to-date.
		history.pushState({}, '', url);

		state.router.props.id = id ? id : '0';
	},
	setErrorMessage: (message) => {
		state.errorMessage = message;
	},
	setImports: (files) => {
		state.storedImports = files;
	},
	setStandAloneLogin: (standAloneLogin) => {
		state.standAloneLogin = standAloneLogin;
	},
	updateImport: (file) => {
		const index = state.storedImports.findIndex((imported) => imported.id === file.id);
		if (index === -1) {
			return;
		}

		state.storedImports[index] = file;
		state.storedImports = [...state.storedImports];
	}
};

export default mutations;
